import { Dropdown } from "@shared/ui";
import {
  ChevronDown,
  Download,
  FileText,
  FileType,
  Loader2,
} from "lucide-react";
import styles from "../download.module.scss";

interface BriefDownloadMenuProps {
  isDownloading: boolean;
  onDownloadDoc: () => void;
  onDownloadPdf: () => void;
}

export function BriefDownloadMenu({
  isDownloading,
  onDownloadDoc,
  onDownloadPdf,
}: BriefDownloadMenuProps) {
  return (
    <Dropdown
      trigger={["click"]}
      disabled={isDownloading}
      overlayStyle={{ zIndex: 1200 }}
      menu={{
        items: [
          {
            key: "doc",
            icon: <FileText size={14} />,
            label: "Download DOC",
            onClick: onDownloadDoc,
          },
          {
            key: "pdf",
            icon: <FileType size={14} />,
            label: "Download PDF",
            onClick: onDownloadPdf,
          },
        ],
      }}
    >
      <button
        type="button"
        disabled={isDownloading}
        className={styles.downloadButton}
      >
        {isDownloading ? (
          <Loader2 size={13} className={styles.spinIcon} />
        ) : (
          <Download size={13} />
        )}
        {isDownloading ? "Downloading…" : "Download"}
        {!isDownloading && <ChevronDown size={12} className={styles.chevron} />}
      </button>
    </Dropdown>
  );
}
